import List from '../Schedule.List.i18n'

export default {
  components: { List },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  created: function() {   console.log('schedule.vue', 'created'); },
  destroyed: function() { console.log('schedule.vue', 'destroyed'); },
  mounted: function() {
    console.log('schedule.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('schedule.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
